export const StockAvailabilityThreshold = {
  UPPER: 12,
  LOWER: 6,
}
